<template>
  <section class="content" v-permission.if="[
    USER_ROLES.ADMIN,
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.GA_HEAD,
    USER_ROLES.JOURNEY_MANAGER,
    USER_ROLES.GIS_USER,
  ]">
    <div class="main_select_wrp_relative">
      <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="width: 50%">
          <div class="modal-content">
            <div class="modal-header">
              <h2>Filters</h2>
              <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilterFilter()">Clear
                All</button>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label>Start Date</label>
              <date-picker id="startDate" v-model="dateFilter.startDateFilter" @change="startDateFilter()" lang="en"
                name="startDate" required input-class="form-control" width="100%" valueType="format"
                :format="'DD-MM-YYYY'" placeholder="Start date">
              </date-picker>
              <label>End Date</label>
              <date-picker id="endDate" lang="en" name="endDate" required v-model="dateFilter.endDateFilter"
                input-class="form-control" width="100%" valueType="format" :not-before="startDateIso"
                :format="'DD-MM-YYYY'" placeholder="End date" @change="endDateFilter()">
              </date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_select_wrp_relative">
      <div class="modal fade model_modify_wrp" id="exportCSV" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="width: 50%">
          <div class="modal-content">
            <div class="modal-header">
              <h2>Export </h2>
              <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilter()">Clear
                All</button>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="col-sm-12" style="padding-bottom: 20px;">
              <div class="modal-body">
                <div class="col-sm-6">
                  <label>Start Date</label>
                  <date-picker id="startDate" v-model="date.startDate" @change="startDate()" lang="en" name="startDate"
                    required input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'"
                    placeholder="Start date">
                  </date-picker>
                </div>
                <div class="col-sm-6">
                  <label>End Date</label>
                  <date-picker id="endDate" lang="en" name="endDate" required v-model="date.endDate"
                    input-class="form-control" width="100%" valueType="format" :not-before="startDateIso"
                    :format="'DD-MM-YYYY'" placeholder="End date" @change="endDate()">
                  </date-picker>
                </div>
              </div>
            </div>
            <div class="col-sm-12 text-right export_CSV">

              <button class="mr-2 btn gradientbt " type="submit" @click="exportCSV">
                Export
              </button>

            </div>

          </div>

        </div>
      </div>
    </div>

    <div>
      <div class="box-body">

        <div class="sorting">
          <div class="col-md-8">
            <select class="form-control" @change="fiteredResult" v-model="statusValue">
              <option value="" disabled>All</option>
              <option value="scheduled">Scheduled</option>
              <option value="ongoing">Ongoing</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
          <div class="col-md-4">
            <button class="btn inline" @click="clearStatus">Clear</button>
          </div>
        </div>
        <div class="sorting1">
          <div class="col-md-8">
            <select class="form-control" @change="fiteredResultGA" v-model="regionValue">
              <option value="all">All GA</option>
              <option v-for="(item, index) in journey_managers" :key="index" :value="item.key">
                {{ item.value }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <button class="btn inline" @click="clearStatusGA">Clear</button>
          </div>
        </div>

        <div :class="addButtonClass" v-permission.if="[
          USER_ROLES.ADMIN,
          USER_ROLES.SUPER_ADMIN,
          USER_ROLES.GA_HEAD,
          USER_ROLES.JOURNEY_MANAGER,
        ]">
          <div class="filter_wrpp filtered">
            <div class="applyFilter">
              <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#"
                  xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                  <g transform="translate(0 -1028.4)">
                    <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                    <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                    <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                    <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                  </g>
                </svg>
                Apply Filter
              </button>
            </div>
          </div>

          <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exportCSV">
            Export
          </button>
          <router-link :to="{ name: 'TripGroupCreate' }">
            <button class="btn addnew">Add New</button>
          </router-link>
        </div>
        <v-server-table ref="tripTable" url :columns="columns" :options="options" v-on:row-click="edit"
          @loaded="onLoaded">
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="9">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="haltsCount" slot-scope="props">
            <div class="active_wrp">
              <a role="button" v-on:click.stop="showArea(props.row)">{{ props.row.subTripDetails.length - 1 }}</a>
            </div>
          </template>
          <template slot="edit" slot-scope="props">
            <div v-permission.if="[
              USER_ROLES.ADMIN,
              USER_ROLES.SUPER_ADMIN,
              USER_ROLES.GA_HEAD,
              USER_ROLES.JOURNEY_MANAGER,
            ]">
              <a v-if="props.row.status == 'ongoing' || props.row.status == 'scheduled'" class="fa fa-edit" role="button"
                v-on:click.stop="UpdateDestination(props.row)"></a>
            </div>
          </template>
        </v-server-table>
      </div>
    </div>
    <div v-if="isAreaTable" class="password-popup">
      <div class="password-popup-width">
        <h4 class="heading_pop">Sub-Trip Details</h4>
        <a class="toggle" v-on:click="closeAreaTableModal">
          <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 29 29"
            xml:space="preserve">
            <path fill="none" stroke="#706c6c" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
              stroke-width="2" d="M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606" />
          </svg>
        </a>
        <div class="table-container">
          <table class="tablePopUp">
            <tr>
              <th>Trip Code</th>
              <th>Start Site</th>
              <th>End Site</th>
            </tr>
            <tr v-for="data in tripDetailsList">
              <td>{{ data.tripCode }}</td>
              <td>{{ data.startSiteSiteName }}</td>
              <td>{{ data.endSiteSiteName }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import Config from '../../../config';
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
  name: 'TripGroup',
  data() {
    return {
      dateFilter: {
        startDateFilter: "",
        endDateFilter: "",

      },
      startDateIsoFilter: "",
      endDateIsoFilter: "",
      date: {
        startDate: "",
        endDate: "",
      },
      startDateIso: "",
      endDateIso: "",
      regionManagersIdList: [],
      tripDetailsList: [],
      isAreaTable: false,
      regionValue: 'all',
      journey_managers: [],
      USER_ROLES: USER_ROLES,
      loading: null,
      tripTable: null,
      parameters: {},
      statusValue: '',
      parameterss: '',
      columns: [
        'tripGroupCode',
        'startSiteSiteName',
        'firstHalt',
        'driverName',
        'vehicle',
        'scheduleDate',
        'haltsCount',
        'status',
        'edit',
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'tripGroupCode',
          'driverName',
          'vehicle',
          'startSiteSiteName',
          'firstHalt',
        ],
        headings: {
          tripGroupCode: 'Group Trip Code',
          driverName: 'Drivers',
          vehicle: 'Vehicle',
          startSiteSiteName: 'Source',
          firstHalt: 'First Halt',
          scheduleDate: 'Schedule Date',
          status: 'Status',
          haltsCount: 'No. of Halts',
        },
        templates: {
          scheduleDate(row, query) {
            if (query.scheduleTime) {
              var [h, m] = query.scheduleTime.split(':');
              var time = `${(h % 12) + 12 * (h % 12 == 0)}${':'}${m} ${h >= 12 ? 'PM' : 'AM'
                }`;
            }
            return `${moment(`${query.scheduleDate}`).format('DD-MM-YYYY')} ${time}`;
          },
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
          driverName(row, query) {
            var drivers = [];
            query.driverId.map(el => {
              drivers.push(el.driverName);
            });
            return drivers.join(', ');
          },
          device(row, query) {
            return query.deviceId.deviceId;
          },
          vehicle(row, query) {
            return query.vehicleId.regNo;
          },
          createdAt(row, query) {
            return moment(`${new Date()}`).format('hh:mm A');
          },
          scheduleTime(row, query) {
            // if (query.scheduleTime){
            return `${moment(`${query.scheduleDate}`).format('DD-MM-YYYY')}`;

            // }
          },
          firstHalt(row, query) {
            return (query.subTripDetails.length > 0 ? query.subTripDetails[0].endSiteSiteName : 'NA');
          },
          haltsCount(row, query) {
            console.log("query.subTripDetails.length -1", query.subTripDetails.length - 1)
            return (query.subTripDetails.length - 1);
          }
        },
        requestFunction: request => {
          this.parameters.page = request.page;
          this.parameters.limit = request.limit;
          if (request.query) {
            this.parameters.searchString = request.query;
          } else {
            delete this.parameters.searchString;
          }
          if (request.orderBy) {
            this.parameters.sortBy = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            this.parameters.sortBy = '-scheduleDate';
          }

          this.loading = true;
          if (this.regionManagersIdList.length !== 0) {
            this.parameters.region = this.regionManagersIdList;
          }
          if (this.parameterss != '') {
            this.parameters.region = this.parameterss;

          }
          return this.$tripGroupDataRepository
            .groupTripApi(this.parameters)
            .catch(error => {
              console.error('trip.requestFunction-error:', error);
              this.$snotify.error('Get Trip', 'Error!');
            });
        },
        responseAdapter: response => {
          console.log('ress', response);
          this.loading = false;
          return {
            data: response.data.data,
            count: response.data.totalCount,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  mounted: function () {
    this.getGeographicalAreas();
  },
  created() {
    let regionDetails = this.$store.state.auth.userRegion.regionDetails
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(item => item._id);
    }

  },
  computed: {
    addButtonClass() {
      if (this.tripTable) {
        return this.tripTable.count > this.tripTable.limit ||
          this.tripTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {

    clearFilterFilter() {

      this.dateFilter.startDateFilter = '';
      this.dateFilter.endDateFilter = '';
      delete this.parameters.startDate;
      delete this.parameters.endDate;
      this.$refs.tripTable.refresh();


    },
    startDateFilter() {
      const eventData = this.dateFilter.startDateFilter.split("-");
      this.startDateIsoFilter = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
    },
    endDateFilter() {
      if (this.dateFilter.startDateFilter != "" && this.dateFilter.endDateFilter != "") {
        const eventData = this.dateFilter.endDateFilter.split("-");
        const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];

        this.parameters.startDate = this.startDateIsoFilter;
        this.parameters.endDate = endDate;
        this.$refs.tripTable.refresh();
      }
    },


    clearFilter() {
      this.date.startDate = '';
      this.date.endDate = '';
    },
    startDate() {
      const eventData = this.date.startDate.split("-");
      this.startDateIso = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
    },
    endDate() {
      const eventData = this.date.endDate.split("-");
      this.endDateIso = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
      console.log('end date', this.endDateIso)
    },
    /*download master data */
    exportCSV() {
      axios({
        method: 'get',
        url: `${Config.serverURI}/v1/exportMaster?startDate=${this.startDateIso}&model=tripgroup&endDate=${this.endDateIso}`,
        responseType: 'arraybuffer'
      })
        .then((response) => {
          console.log("response of download", response)
          const arrayBuffer = response.data
          const filename = 'Group_Trip.xlsx';
          this.downloadFileFromArrayBuffer(arrayBuffer, filename);
        }).catch((err) => {
          console.log("err", err)
        })

    },
    /*download file */
    downloadFileFromArrayBuffer(arrayBuffer, filename) {
      const url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },



    closeAreaTableModal() {
      if (this.isAreaTable) {
        this.isAreaTable = !this.isAreaTable;
      }
    },
    showArea(row) {
      this.isAreaTable = true;
      this.tripDetailsList = row.subTripDetails
    },

    clearStatusGA() {
      this.parameterss = '';
      delete this.parameters['region'];
      this.regionValue = 'all';
      this.$refs.tripTable.refresh();
    },
    fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameterss = ''
        delete this.parameters['region'];
        this.regionValue = 'all';
      } else {
        this.parameterss = e.target.value;
      }

      this.$refs.tripTable.refresh();
    },
    getGeographicalAreas() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let journeyManagerList = [];

      this.$regionsDataRepository.list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            if (this.user.roleName === 'Admin') {
              journeyManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.name,
                };
              });
              this.journey_managers = journeyManagerList;
            } else {
              journeyManagerList = res.data.docs.map(item => {
                if (this.regionManagersIdList.includes(item._id)) {
                  this.journey_managers.push({
                    key: item._id,
                    value: item.name,
                  });
                }
              });
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('journey Manager.requestFunction-error:', error);
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },
    clearStatus() {
      delete this.parameters['tripStatus'];
      this.statusValue = '';
      this.$refs.tripTable.refresh();
    },
    fiteredResult(e) {
      if (e.target.value == 'ongoing') {
        this.parameters = {
          ...this.parameters,
          tripStatus: 'ongoing',
        };
      }
      if (e.target.value == 'scheduled') {
        this.parameters = {
          ...this.parameters,
          tripStatus: 'scheduled',
        };
      }
      if (e.target.value == 'completed') {
        this.parameters = {
          ...this.parameters,
          tripStatus: 'completed',
        };
      }
      if (e.target.value == 'cancelled') {
        this.parameters = {
          ...this.parameters,
          tripStatus: 'cancelled',
        };
      }
      this.$refs.tripTable.refresh();
    },
    UpdateDestination(row) {
      if (row.status == 'ongoing' || row.status === 'scheduled') {
        this.$router.push({
          name: 'UpdateLocations',
          params: {
            _id: row._id,
          },
          props: row,
        });
      }
    },
    edit(data) {
      if (data.row.status == 'ongoing' || data.row.status == 'completed') {
        this.$router.push({
          name: 'Trip-Group-Activity',
          params: { _id: data.row._id },
          props: data.row,
        });
      } else if (data.row.status == 'scheduled') {
        this.$router.push({
          name: 'TripGroupDetail',
          params: { _id: data.row._id },
          props: data.row,
        });
        // } else if (data.row.status == 'scheduled') {
        //   this.$router.push({
        //     name: 'tripGroupDetail',
        //     params: { _id: data.row._id },
        //     props: data.row,
        //   });
        // }
      }
    },
    onLoaded() {
      this.tripTable = this.$refs.tripTable;
    },
  }

};
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 225px;
  margin-left: 250px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
  background-color: rgba(255, 132, 78);
  color: white;
}

.addnew {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}

.sorting1 {
  position: absolute;
  left: 550px;
  z-index: 1000;
  width: 350px;
  margin-left: 250px;
}

.password-popup {
  height: 100%;
  width: 100%;
  z-index: 10;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  text-align: center;
  box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
  z-index: 9999;
  background-color: rgb(0 0 0 / 50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-popup-width {
  padding-top: 0px;
  background: #fff;
  width: 500px;
  height: auto;
  padding: 0px !important;
  border-radius: 10px;
  position: relative;
}

.password-popup-width .toggle {
  box-shadow: none;
  border: none;
  width: auto;
  position: absolute;
  right: 10px;
  top: 20px;
}

.password-popup-width .toggle svg {
  width: 22px;
  height: 22px;
}

h4.heading_pop {
  background: #f1f1f1;
  padding: 20px;
  margin: 0;
  border-bottom: 1px solid #ddd;
  text-align: center;
  /* margin-bottom: 10px; */
  border-radius: 5px 5px 0px 0px;
}

/* Style for the entire table container */
.table-container {
  max-height: 300px;

  overflow: auto;

}

.tablePopUp {
  width: 100%;

  border-collapse: collapse;

  margin-bottom: 20px;

}


.tablePopUp th {
  background-color: #f2f2f2;

  font-weight: bold;

  text-align: left;

  padding: 10px;

  border: 1px solid #ccc;

}


.tablePopUp tr {
  border: 1px solid #ccc;
}

.tablePopUp tr:nth-child(odd) {
  background-color: #f9f9f9;

}

.tablePopUp td {
  padding: 10px;
  text-align: left;

}

.tablePopUp tr:hover {
  background-color: #e0e0e0;

}

.applyFilter {
  position: absolute;
  top: 0px;
  right: 186px;
  z-index: 100;
}

.export_CSV {
  padding: 7PX 0PX;
  border-top: 1px solid #ddd;
  padding-right: 42PX;
}
</style>



// WEBPACK FOOTER //
// TripGroup.vue?e9a4d188